// General
import "./education-filter-dialog.scss";
import { useEffect, forwardRef } from "react";
// Redux
import { useSelector, useDispatch } from "react-redux";
import { updateEducationFilterDialog } from "../../../../../redux/store/dialogStore";
// react-gtm-module
import TagManager from "react-gtm-module";
// Material UI
import { Dialog, Slide } from "@mui/material";
// Components
import EducationFilter from "../../../elements/filters/education-filter/education-filter";

const EducationFilterDialog = () => {
  // Redux variables
  const educationFilterDialog = useSelector(
    (state) => state.dialog.educationFilterDialog
  );
  const dispatch = useDispatch();

  // Lifecycle | Mounted
  useEffect(() => {
    if (!educationFilterDialog) return;

    TagManager.dataLayer({
      dataLayer: {
        event: "PWA-EducationFilter-Dialog",
      },
    });
  }, [educationFilterDialog]);

  // Event Handlers | MUI Dialog
  const onCloseDialog = () => {
    dispatch(updateEducationFilterDialog(false));
  };

  return (
    <Dialog
      className="custom-bottom-sheet-dialog"
      fullScreen
      open={educationFilterDialog}
      TransitionComponent={Transition}
      onClose={onCloseDialog}
    >
      <EducationFilter />
    </Dialog>
  );
};

export default EducationFilterDialog;

// Render Functions | MUI Dialog | Will not work if inside of the same render as the Dialog
const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
